<template>
  <div>
    <v-row class="mt-2 mb-n4">
      <v-col cols="12">
        <slot name="title">
          <span class="title">{{ title }}</span>
        </slot>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="mt-n12">
        <RateVerificationTable
          :items="items"
          :groupingKeys="groupingKeys"
          :expandToContract="expandToContract"
          :hideEditAndUnpostActions="hideEditAndUnpostActions"
          :tractId="tractId"
          :expansionPanelKey="expansionPanelKey"
          :hideContractCards="hideContractCards"
          @refresh-batch="$emit('refresh-batch')"
          @contract-edited="$emit('contract-edited')"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'RateVerification',

  components: {
    RateVerificationTable: () => import('@/components/settlements/rate-verification/RateVerificationTable.vue')
  },

  props: {
    items: {
      type: Array,
      required: true
    },
    groupingKeys: {
      type: Array,
      required: true
    },
    expandToContract: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    hideEditAndUnpostActions: {
      type: Boolean,
      default: false
    },
    tractId: {
      type: Number,
      required: false
    },
    expansionPanelKey: {
      type: String,
      required: false
    },
    hideContractCards: {
      type: Boolean,
      default: false
    }
  }
}
</script>
